<template>
  <main class="main-tag">
    <div
      class="register-page"
      :class="!isDefaultEnvironment ? 'portal-register' : ''"
    >
      <div
        class="background-img"
        v-if="!isDefaultEnvironment"
        :class="isSKS ? 'sks-bg' : ''"
      ></div>

      <q-form
        v-if="!registrationFormSubmitted"
        @submit="submitForm"
        @reset="resetForm"
        class="login-form"
      >
        <div v-if="!isDefaultEnvironment" class="column q-pt-xl">
          <h4 class="q-mb-md welcome-heading-text" style="padding-top: 18px">
            Welkom op Vindsubsidies loket {{ customerPortalSignatureName }}
          </h4>
          <p class="sub-welcome-text">
            Vind relevante subsidies door je te registeren
          </p>
        </div>
        <h4 v-else>Registreer</h4>
        <div class="inputs">
          <div class="name-inputs">
            <div class="input-field">
              <q-input
                dense
                bg-color="white"
                borderless
                v-model="register.firstName"
                label="Voornaam"
                style="width: 263px"
                aria-describedby="first-name-error"
                :aria-invalid="!!firstNameError"
                @blur="touched.firstName = true"
              />
              <div v-if="firstNameError">
                <div id="first-name-error" class="error-msg" role="alert">
                  {{ firstNameError }}
                </div>
                <i
                  class="q-icon text-negative notranslate material-icons"
                  :aria-lebel="t('common.error_message')"
                  >error</i
                >
              </div>
            </div>
            <div class="input-field">
              <q-input
                dense
                bg-color="white"
                v-model="register.lastName"
                label="Achternaam"
                borderless
                style="width: 263px"
                aria-describedby="last-name-error"
                :aria-invalid="!!lastNameError"
                @blur="touched.lastName = true"
              />
              <div v-if="lastNameError">
                <div id="last-name-error" class="error-msg" role="alert">
                  {{ lastNameError }}
                </div>
                <i
                  class="q-icon text-negative notranslate material-icons"
                  :aria-lebel="t('common.error_message')"
                  >error</i
                >
              </div>
            </div>
            <div class="input-field">
              <q-input
                dense
                bg-color="white"
                v-model="register.email"
                borderless
                label="E-mailadres"
                style="width: 263px"
                aria-describedby="email-error"
                :aria-invalid="!!emailError"
                @blur="touched.email = true"
              />
              <div v-if="emailError">
                <div id="email-error" class="error-msg" role="alert">
                  {{ emailError }}
                </div>
                <i
                  class="q-icon text-negative notranslate material-icons"
                  :aria-lebel="t('common.error_message')"
                  >error</i
                >
              </div>
            </div>
            <div class="input-field">
              <q-select
                v-if="isSKS"
                dense
                bg-color="white"
                label="Wie ben je?"
                borderless
                v-model="register.professionType"
                :options="professionTypes"
                option-label="name"
                style="min-width: 263px"
                aria-describedby="profession-type-error"
                :aria-invalid="!!professionTypeError"
                @blur="touched.professionType = true"
              />
              <div v-if="professionTypeError">
                <div id="profession-type-error" class="error-msg" role="alert">
                  {{ professionTypeError }}
                </div>
                <i
                  class="q-icon text-negative notranslate material-icons"
                  :aria-lebel="t('common.error_message')"
                  >error</i
                >
              </div>
            </div>
            <div class="input-field">
              <q-input
                v-if="isDefaultEnvironment"
                dense
                bg-color="white"
                v-model="register.confirmEmail"
                label="Emailconfirm"
                borderless
                style="width: 263px"
                aria-describedby="confirm-email-error"
                :aria-invalid="!!confirmEmailError"
                @blur="touched.confirmEmail = true"
              />
              <div v-if="confirmEmailError">
                <div id="confirm-email-error" class="error-msg" role="alert">
                  {{ confirmEmailError }}
                </div>
                <i
                  class="q-icon text-negative notranslate material-icons"
                  :aria-lebel="t('common.error_message')"
                  >error</i
                >
              </div>
            </div>
          </div>
        </div>
        <div class="terms-and-conditions" style="margin-top: 24px">
          <q-list v-if="isDefaultEnvironment">
            <q-item>
              <q-item-section>
                <q-item-label style="text-align: left"
                  ><strong>Voorwaarden</strong></q-item-label
                >
                <q-item-label
                  style="text-align: left"
                  caption
                  class="font-dark"
                >
                  We willen u laten weten hoe Vindsubsidies namens
                  {{ customerPortalName }} werkt en waarom we uw
                  registratiegegevens nodig hebben (al uw persoonlijke
                  registratiegegevens staan hierboven vermeld).
                  <br />
                  (<a
                    href="https://ignite-group.com/wp-content/uploads/2025/02/250220-Gebruiksvoorwaarden-subsidieinformatiedienst-Ignite-Group.pdf"
                    >Bekijk gebruiksvoorwaarden</a
                  >)
                </q-item-label>

                <q-field
                  :model-value="register.terms"
                  :rules="[acceptedTerms]"
                  borderless
                  dense
                >
                  <template v-slot:control>
                    <q-checkbox
                      class="q-pt-sm"
                      dense
                      v-model="register.terms"
                      color="primary"
                      label="Ik accepteer de algemene voorwaarden"
                    />
                  </template>
                </q-field>
              </q-item-section>
            </q-item>
            <q-item>
              <q-item-section>
                <q-item-label style="text-align: left"
                  ><strong>Uw persoonlijke informatie</strong></q-item-label
                >
                <q-item-label
                  caption
                  style="text-align: left"
                  class="font-dark"
                >
                  Volgens de nieuwe Algemene Verordening Gegevensbescherming
                  (AVG) moet u instemmen met uw gegevens (al uw persoonlijke
                  registratiegegevens staan hierboven vermeld) die worden
                  opgeslagen en gebruikt om u de diensten van Vindsubsidies
                  namens
                  {{ customerPortalName }} aan te bieden. Wij gebruiken deze
                  gegevens alleen voor de doeleinden van:
                  <ul>
                    <li>Toegang te verschaffen tot deze portal</li>
                    <li>
                      E-mails te versturen met betrekking tot het opnieuw
                      instellen van uw wachtwoord
                    </li>
                    <li>
                      E-mails te versturen met betrekking tot wijzigingen in
                      subsidieregelingen, op basis van het door u opgeslagen
                      bewaarde zoekactie
                    </li>
                    <li>
                      Om uw contactgegevens en site gebruik door te geven aan
                      {{ customerPortalName }}
                    </li>
                  </ul>
                </q-item-label>
              </q-item-section>
            </q-item>
            <q-item>
              <q-item-section>
                <q-item-label style="text-align: left"
                  ><strong>Toestemming</strong></q-item-label
                >
                <q-field
                  :model-value="register.permission"
                  :rules="[acceptedPermission]"
                  borderless
                  dense
                >
                  <template v-slot:control>
                    <q-checkbox
                      class="q-pt-sm"
                      dense
                      v-model="register.permission"
                      color="primary"
                      label="Ik stem ermee in dat mijn gegevens gebruikt worden voor de bovengenoemde doeleinden"
                    />
                  </template>
                </q-field>
              </q-item-section>
            </q-item>
          </q-list>
          <div v-else class="terms-checkbox q-my-md">
            <q-checkbox
              dense
              v-model="register.terms"
              :label="`Ja, ik geef toestemming voor de verwerking van mijn gegevens en ik wil op de hoogte gehouden worden over subsidies in ${customerPortalNameNoUpper} over *geselecteerde onderwerpen*.`"
              class="checkbox-terms"
            />
          </div>
        </div>
        <div class="q-pb-md">
          <q-btn
            label="Registreer"
            type="submit"
            class="bold-font orange-btn-filled q-mb-md"
            :disabled="isRegisterBtnDisabled"
            no-caps
          />
          <div class="register-btn" v-if="!isDefaultEnvironment">
            <p><strong>Heb je al een account?</strong></p>
            <q-btn
              no-caps
              class="bold-font orange-btn q-mb-md"
              style="max-width: 124px; text-decoration: none"
              label="Inloggen"
              :to="{ name: 'Login' }"
            />
          </div>
        </div>
      </q-form>
      <div v-else class="submitted-page">
        <div class="row justify-center align-center">
          <div class="col-6">
            <div class="column submit-heading">
              <div class="text-h5 q-pb-xl">Bedankt voor het registreren!</div>
              <label class="submit-label q-pt-md">
                U ontvangt binnen 2 minuten de registratielink.<br />
                <strong>Let op! </strong> De mail is afkomstig van
                Vindsubsidies. Indien deze niet binnen komt, check dan ook uw
                spam.
              </label>
              <q-btn
                no-caps
                class="bold-font orange-btn-filled q-my-lg"
                style="max-width: 124px; text-decoration: none"
                label="Verder"
                :to="{ name: 'Login' }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { reactive, onMounted, computed, ref } from "vue";
import authService from "../services/auth.service";
import store from "../store/index";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const registrationFormSubmitted = ref(false);
    const { t } = useI18n();

    const register = reactive({
      firstName: "",
      lastName: "",
      email: "",
      confirmEmail: "",
      organisation: null,
      terms: false,
      permission: false,
      professionType: "",
    });

    const touched = reactive({
      firstName: false,
      lastName: false,
      email: false,
      confirmEmail: false,
      professionTypeError: false,
    });

    onMounted(async () => {
      await authService.getEnvironment();
      await authService.getPortalInfo();
      await authService.getPortalTypes();
      await authService.getProfessionTypes();
    });

    const professionTypes = computed(() => store.state.auth.professionTypes);
    const isSKS = computed(() => store.state.auth.env === 30);
    const customerPortalName = computed(
      () => store.state.auth.customer.customerPortalName,
    );
    const customerPortalSignatureName = computed(
      () => store.state.auth.customer.customerPortalSignatureName,
    );
    const noUpperCasePortalName = computed(
      () => store.state.auth.customerPortalNameNoUpper,
    );
    const isDefaultEnvironment = computed(
      () => store.state.auth.env === 0 || store.state.auth.env === 40,
    );
    const customerPortalNameNoUpper = computed(
      () => store.state.auth.customerPortalNameNoUpper,
    );
    const firstNameError = computed(() =>
      isValueProvided(register.firstName, touched.firstName, "first_name") ===
      true
        ? ""
        : isValueProvided(register.firstName, touched.firstName, "first_name"),
    );
    const lastNameError = computed(() =>
      isValueProvided(register.lastName, touched.lastName, "last_name") === true
        ? ""
        : isValueProvided(register.lastName, touched.lastName, "last_name"),
    );
    const emailError = computed(() => {
      if (isValueProvided(register.email, touched.email, "email") !== true)
        return isValueProvided(register.email, touched.email, "email");
      else if (isValidEmail(register.email) !== true)
        return isValidEmail(register.email);
      else return "";
    });
    const confirmEmailError = computed(() => {
      if (
        isValueProvided(
          register.confirmEmail,
          touched.confirmEmail,
          "email",
        ) !== true
      )
        return isValueProvided(
          register.confirmEmail,
          touched.confirmEmail,
          "email",
        );
      else if (isConfirmedEmail(register.confirmEmail) !== true)
        return isConfirmedEmail(register.confirmEmail);
      else return "";
    });
    const professionTypeError = computed(() =>
      isValueProvided(register.professionType, touched.professionType) === true
        ? ""
        : isValueProvided(register.professionType, touched.professionType),
    );

    const isConfirmedEmail = (val) => {
      return val === register.email || "Emailadressen zijn niet gelijk";
    };

    const isValueProvided = (val, isTouched, fieldName) => {
      if (!isTouched) return "";
      return (
        (val && val.length > 0) ||
        t(`validation.${fieldName}_error`, fieldName || "field")
      );
    };

    const isValidEmail = (val) => {
      const emailPattern =
        /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      return emailPattern.test(val) || "Ongeldig e-mailadres";
    };

    const isRegisterBtnDisabled = ref(false);

    const submitForm = async () => {
      isRegisterBtnDisabled.value = true;
      await authService.register(register);
      registrationFormSubmitted.value = true;
      isRegisterBtnDisabled.value = false;
    };

    const resetForm = () => {
      register.email = "";
      register.confirmEmail = "";
      register.organisation = null;
      register.firstName = "";
      register.lastName = "";
      register.terms = false;
      register.permission = false;
      register.professionType = "";
    };

    const acceptedTerms = (val) => {
      return (
        val ||
        "Je dient akkoord te geven op de verwerking van je gegevens en de algemene voorwaarden."
      );
    };

    const acceptedPermission = (val) => {
      return (
        val ||
        "Je dient akkoord te geven op de verwerking van je gegevens en de algemene voorwaarden."
      );
    };

    return {
      isRegisterBtnDisabled,
      isSKS,
      customerPortalNameNoUpper,
      customerPortalSignatureName,
      register,
      professionTypes,
      isDefaultEnvironment,
      customerPortalName,
      noUpperCasePortalName,
      registrationFormSubmitted,
      firstNameError,
      lastNameError,
      emailError,
      confirmEmailError,
      professionTypeError,
      touched,
      submitForm,
      resetForm,
      acceptedTerms,
      acceptedPermission,
    };
  },
};
</script>
